<template>
  <div class="setting_profile_image">
    <p><router-link to="/setting_profile">＜ 設定に戻る</router-link></p>
    <br>
    <h1 class="title is-5">プロフィール画像の設定</h1>
    <div class="setting_profile_image_file">
      <b-field class="file">
        <b-upload v-model="file">
          <a class="button is-info">
            <b-icon icon="file" style="color:white;"></b-icon>
            <span style="color:white;">ファイルを選択</span>
          </a>
        </b-upload>
        <span class="file-name" v-if="file">
          {{ file.name }}
        </span>
        <b-button v-if="file" @click="deleteFile">x</b-button>
      </b-field>
      <img :src="image" />
      <br>
    </div>
    <b-button v-if="file" @click="postFile">設定する</b-button>
  </div>
</template>

<script>
import firebase from 'firebase/app'
export default {
  data(){
    return {
      file:null,
    }
  },
  computed:{
    image(){
      return this.file ? window.URL.createObjectURL(this.file) : ""
    },
    user(){
      return this.$store.getters.user;
    },
  },
  mounted(){
    const title = "画像設定｜イラスト頑張るクラブ"
    const description = "イラスト頑張るクラブの画像設定画面です。"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
  },
  methods:{
    deleteFile(){
      this.file = null
    },
    postFile(){
      const storageRef = firebase.storage().ref();
      const fileRef = storageRef.child(this.user.uid + '.jpeg');
      fileRef.put(this.file).then(() => {
        fileRef.getDownloadURL().then(url =>{
          firebase.firestore().collection('user').doc(this.user.uid).set({
                user_image: url,
            },{ merge: true }
          )
        })
      }).then(()=>{
        this.$buefy.toast.open('画像登録しました')
        this.$router.push({ name: 'setting_profile'})
      });
    }
  }
}
</script>

<style scoped>
.setting_profile_image{
  margin: auto;
  max-width: 800px;
  padding:30px;
}

</style>